import styled from 'styled-components';

import {OverlapImage} from 'src/images';

export const Image = styled(OverlapImage)`
  display: flex;
  margin: ${({theme}) => theme.spacing.s6} auto 0;
`;
